class FacetRemove extends HTMLElement {
  constructor() {
    super()
    const e = this.querySelector('a')
    e.addEventListener('click', (t) => {
      t.preventDefault()
      ;(this.closest('collection-filters-form') || document.querySelector('collection-filters-form')).renderPage(
        new URL(e.href).searchParams.toString()
      )
    })
  }
}
customElements.define('facet-remove', FacetRemove)
